import getAttachmentPolicy from 'owa-session-store/lib/utils/getAttachmentPolicy';

export function getWacPreloadMappings() {
    const wacPreloadList: string[][] = (getAttachmentPolicy().WacPreloadMappings as any) || [];

    return wacPreloadList.reduce<{ [ext: string]: string }>((mapping, [extension, preloadUrl]) => {
        mapping[extension] = preloadUrl;
        return mapping;
    }, {});
}
